import Vue from 'vue'

export default {
  created () {
    let parent = this.$parent

    // 最多向上5层
    for (let i = 0; i < 5; i++) {
      if (parent && parent.$event) {
        this.$event = parent.$event
        break
      } else if (parent.$parent) {
        parent = parent.$parent
      }
    }

    if (!this.$event) {
      this.$event = new Vue()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/event.js